import React, { useState, useEffect } from 'react';
import { Dropdown, DropdownToggle, DropdownMenu, DropdownItem ,Badge} from 'reactstrap';
import CitiesServices from "services/Admin/CitiesService"
import DeleteModal from "../DeleteModal"
import AvField from "availity-reactstrap-validation/lib/AvField";
import AvForm from "availity-reactstrap-validation/lib/AvForm";
import { SuccessOk } from 'configs/statusCode';
import { toast } from 'react-toastify';
import { useSelector } from "react-redux"
import ClientsService from 'services/Admin/ClientsService';
import EditClientModal from 'components/Website/Cards/EditClient';

const CardItem = (props) => {
    const { index, item, id, name, status, setShouldGetData} = props
    const [deleteModal, setDeleteModal] = useState(false);
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [itemStatus, setItemStatus] = useState(false);
    const [editModal, setEditModal] = useState(false)
    const AuthData = useSelector(state => state.Auth)
    const isExist = (data) => (AuthData.permissions.includes(data) || AuthData.email === "admin@meras.com")
    const service = new ClientsService()
    const toggle = () => setDropdownOpen(prevState => !prevState);

    useEffect(() => {
        setItemStatus(status)
         
    }, [status])
    const handleCloseModal = (action, response) => {
        setDeleteModal(false);
        if (action === "delete") {
            setShouldGetData(true)
        }
    };
    const handleCloseEditModal = (action, response) => {
        setEditModal(false);
        if (action === "edit") {
            setShouldGetData(true)
        }
    };
 

    const changeStatus = (e) => {
        const value = e.target.checked
        
        service.toggleStatus(item.id).then((res) => {
            if (res && res.status === SuccessOk) {
                setItemStatus(value)
                toast.success("Status changed successfully");
                setTimeout(() => {
                    setShouldGetData(true)
                }, 1000);
            }
        });
    }

    return (
        <>
            <tr key={index}>
                <th className='font-size-14'>{item.id}</th>
                <th className='font-size-14' style={{textDecoration:"underLine",fontWeight:700}}>{item.name} </th>
                <th className='font-size-14'>{item.user_name}</th>
                <th className='font-size-14'>{item.email}</th>
                <th className='font-size-14'>{item.phone}</th>
                <td className='font-size-14 py-0'>
                    <form>
                        <div className='form-check form-switch form-switch-md mb-1'>
                            <input
                                name='status'
                                checked={itemStatus}
                                type='checkbox'
                                className='form-check-input'
                                id='has_status'
                                onChange={changeStatus}
                                // disabled={isExist("seller.edit") ? false:true}
                            />
                        </div>
                    </form>
                </td>
                {/* <td className='font-size-16'>{status ? "true" : "false"}</td> */}
                {isExist("seller.delete") ? <td className="removebtnhover"><Dropdown className="dropdownWidth" color="light" isOpen={dropdownOpen} toggle={toggle}>
                    <DropdownToggle caret>
                        <i className="fa fa-ellipsis-v text-dark fa-lg"></i>
                    </DropdownToggle>
                    <DropdownMenu>
                        <DropdownItem onClick={() => setEditModal(true)}>Edit</DropdownItem>
                        <DropdownItem className="text-danger" onClick={() => {
                            setShouldGetData(false)
                            setDeleteModal(!deleteModal);
                        }}>Remove Client</DropdownItem>
                    </DropdownMenu>
                </Dropdown> </td>:null}
            </tr>

            {editModal && <EditClientModal 
                        modal={editModal} 
                        Service={ClientsService}
                        setShouldGetData={setShouldGetData}
                        onCloseModal={(action) => handleCloseEditModal(action)} 
                        form={item} />}
            <DeleteModal
                open={deleteModal}
                titleMsg={name}
                deletedItem={item}
                modelService={service}
                setShouldGetData={setShouldGetData}
                onCloseModal={(action) => handleCloseModal(action)}
            />
        </>

    );
}

export default CardItem;